









import { Component, Vue, Prop } from "vue-property-decorator";
import BinaryInput from "@/basics/inputs/BinaryInput.vue";
import CheckRoomInputs, {
  CheckInputsClickEvent,
  CheckBoxItem
} from "@/components/inputs/CheckRoomInputs.vue";
import { ONE_BUILDING, OneBuildingData } from "@/graphql/query/building/one";

export interface Room extends CheckBoxItem {
  id: string;
  name: string;
}

@Component<RoomListCheckbox>({
  components: { BinaryInput, CheckRoomInputs },
  apollo: {
    rooms: {
      query: ONE_BUILDING,
      variables() {
        return {
          id: this.buildingId
        };
      },
      update(data: OneBuildingData): Room[] {
        const selectedIds: string[] = [];
        const rooms: Room[] = [];
        for (const roomData of data.building.roomFeed.rooms) {
          // 割り当て済みの部屋であれば選択済みにする
          const isSelected = roomData.appUserFeed.appUsers.find(
            a => a.id === this.appUserId
          );
          if (isSelected) {
            selectedIds.push(roomData.id);
          }

          rooms.push({
            ...roomData,
            value: roomData.id,
            disabled: !roomData.allowedActions.includes("assignAppUser")
          } as Room);
        }

        (this as RoomListCheckbox).input(selectedIds);
        return rooms;
      }
    }
  },
  watch: {
    appUserId() {
      this.$apollo.queries.rooms.refresh();
    }
  }
})
export default class RoomListCheckbox extends Vue {
  @Prop({ type: String, required: true })
  buildingId!: string;
  @Prop({ type: String, required: true })
  appUserId!: string;
  @Prop({ type: Array, required: false, default: [] })
  value!: string[];

  rooms: Room[] = [];

  get loading(): boolean {
    return this.$apollo.loading;
  }

  input(event: string[]) {
    this.$emit("input", event);
  }

  click(event: CheckInputsClickEvent) {
    const room = this.rooms[event.index];

    // 選択できないチェックボックスを押した場合、アラートを出す
    if (room.disabled) {
      alert(`${this.rooms[event.index].name}を操作する権限がありません。`);
    }
  }
}
